export const GET_SUPPORT_ITEM_TYPES = "GET_SUPPORT_ITEM_TYPES";
export const GET_SUPPORT_ITEM_TYPE_BY_ID = "GET_SUPPORT_ITEM_TYPE_BY_ID";
export const UPDATE_SUPPORT_ITEM_TYPE = "UPDATE_SUPPORT_ITEM_TYPE";
export const DELETE_SUPPORT_ITEM_TYPE = "DELETE_SUPPORT_ITEM_TYPE";
export const CREATE_SUPPORT_ITEM_TYPE = "CREATE_SUPPORT_ITEM_TYPE";
